import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

/**
 * Validates that the progId parameter matches the expected prog-{id} pattern.
 * If not, redirects to the root path.
 */
export const ProgramRouteValidator: React.FC = () => {
  const { progId } = useParams<{ progId: string }>();

  // Check if progId matches the prog-{id} pattern
  if (!progId || !progId.startsWith('prog-')) {
    // Invalid progId pattern, redirect to root
    return <Navigate to="/" replace />;
  }

  // Valid progId, render child routes
  return <Outlet />;
};
